import { createRouter, createWebHistory } from 'vue-router'

import LoginPage from '../views/LoginPage.vue'
import ResetPasswordPage from '../views/ResetPasswordPage.vue'
import DashboardView from '@/views/DashboardView.vue'
import SettingsView from '@/views/SettingsView.vue'
import ClientView from '@/views/ClientView.vue'
import AppointementList from '@/views/AppointementList.vue'
import AppointementNew from '@/views/AppointementNew.vue'
import AppointementEdit from '@/views/AppointementEdit.vue'
import AppointmentsImport from '@/views/AppointmentsImport.vue'
import ClientDetails from '@/views/ClientDetails.vue'
import ServicesCatalog from '@/views/ServicesCatalog.vue'
import StaffRegistry from '@/views/StaffRegistry.vue'
import StaffDetails from '@/views/StaffDetails.vue'
import LoyaltyMarketing from '@/views/LoyaltyMarketing.vue'
import PromoFideliteView from '@/views/PromoFideliteView.vue'
import PromotionsView from '@/views/PromotionsView.vue'
import CashRegister from '@/views/CashRegister.vue'
import TransactionsLedger from '@/views/TransactionsLedger.vue'
import PaymentSuccess from '@/views/PaymentSuccess.vue'
import StaffSchedule from '@/views/StaffSchedule.vue'
import CalendarEmploye from '@/views/CalendarEmploye.vue'
import CalendarView from '@/views/CalendarView.vue'
import StaffCreation from '@/views/StaffCreation.vue'
import ClientNew from '@/views/ClientNew.vue'
import SalonServiceCreation from '@/views/SalonServiceCreation.vue'
import SalonCategoryCreation from '@/views/SalonCategoryCreation.vue'
import BulkServiceCreation from '@/views/BulkServiceCreation.vue'
import BulkCategoryCreation from '@/views/BulkCategoryCreation.vue'
import SubscriptionPlans from '@/views/SubscriptionPlans.vue'
import PreviewSalonView from '@/views/PreviewSalonView.vue'
import NotFound from '@/views/NotFound.vue'

const routes = [
  { path: '/finance', name: 'TransactionsLedger', component: TransactionsLedger },
  { path: '/payment-success', name: 'PaymentSuccess', component: PaymentSuccess },
  { path: '/subscription/plans', name: 'SubscriptionPlans', component: SubscriptionPlans },
  { path: '/appointments', name: 'CalendarView', component: CalendarView },
  { path: '/appointments/calendar', name: 'CalendarEmploye', component: CalendarEmploye },
  { path: '/staff/schedules', name: 'StaffSchedule', component: StaffSchedule },
  { path: '/login', name: 'login', component: LoginPage },
  { path: '/reset-password/:token', name: 'ResetPassword', component: ResetPasswordPage },
  { path: '/caisse', name: 'CashRegister', component: CashRegister },
  { path: '/Loyalty', name: 'LoyaltyMarketing', component: LoyaltyMarketing },
  { path: '/promotions-fidelite', name: 'PromoFidelite', component: PromoFideliteView },
  { path: '/promotions', name: 'Promotions', component: PromotionsView },
  { path: '/staff/:id', name: 'StaffDetails', component: StaffDetails },
  { path: '/services', name: 'ServicesCatalog', component: ServicesCatalog },
  { path: '/services/new', name: 'SalonServiceCreation', component: SalonServiceCreation },
  { path: '/services/bulk', name: 'BulkServiceCreation', component: BulkServiceCreation },
  { path: '/services/categories', name: 'SalonCategoryCreation', component: SalonCategoryCreation },
  { path: '/services/categories/bulk', name: 'BulkCategoryCreation', component: BulkCategoryCreation },
  { path: '/staff', name: 'StaffRegistry', component: StaffRegistry },
  { path: '/staff/new', name: 'StaffCreation', component: StaffCreation },
  { path: '/appointments/list', name: 'AppointementList', component: AppointementList },
  { path: '/appointments/new', name: 'AppointementNew', component: AppointementNew },
  { path: '/appointments/edit/:id', name: 'AppointementEdit', component: AppointementEdit },
  { path: '/appointments/import', name: 'AppointmentsImport', component: AppointmentsImport },
  { path: '/', name: 'dashboard', component: DashboardView },
  { path: '/clients/:id', name: 'ClientDetails', component: ClientDetails },
  { path: '/settings', name: 'settings', component: SettingsView },
  { path: '/preview-salon', name: 'PreviewSalon', component: PreviewSalonView },
  { path: '/clients', name: 'clients', component: ClientView },
  { path: '/clients/new', name: 'ClientNew', component: ClientNew },

  // 🗓️ Nouvelle route : Intercepte le retour Google Calendar
  { 
    path: '/calendar/google/callback', 
    name: 'GoogleCalendarCallback', 
    component: () => import('@/views/GoogleCalendarCallbackView.vue') 
  },

  // Route 404 - doit être en dernier pour capturer toutes les routes non définies
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Guard de navigation pour protéger les routes
router.beforeEach(async (to, _from, next) => {
  const token = localStorage.getItem('token')
  const isLoginPage = to.path === '/login'
  
  // 🔓 Ajout des routes publiques qui ne nécessitent PAS de token pour fonctionner
  const isPublicRoute = to.path.startsWith('/reset-password/') || to.path === '/calendar/google/callback'

  // Si l'utilisateur n'est pas authentifié et essaie d'accéder à une page protégée
  if (!token && !isLoginPage && !isPublicRoute) {
    next('/login')
  }
  // Si l'utilisateur est authentifié et essaie d'accéder à la page de login
  else if (token && isLoginPage) {
    next('/')
  }
  // Vérifier si l'utilisateur essaie d'accéder aux pages staff avec un compte Solo
  else if (to.path.startsWith('/staff')) {
    const accountType = localStorage.getItem('accountType')

    // Si le type de compte n'est pas encore chargé, laisser passer (sera géré par le composant)
    if (!accountType) {
      next()
    }
    // Si c'est un compte solo, rediriger vers le dashboard avec un message
    else if (accountType === 'solo') {
      console.warn('⚠️  Accès refusé: Fonctionnalité réservée aux plans Équipe et Salon')
      next('/?upgrade=staff')
    }
    else {
      next()
    }
  }
  // Sinon, laisser passer
  else {
    next()
  }
})

export default router